import React from "react";
import "./Cement.css";

function Cement() {
  return (
    <div className="cementmain">
      <div className="feedback">
        <div className="cementpp">
          <p>Cement Chain Application</p>
          <div>
            {/* <p className="c3"><abbr title="Go To Swajit Engineering Pvt.Ltd">Swajit Engineering Pvt.Ltd:/</abbr>
          <a href="https://www.swajit.com/"></a> >Cement Chain Application</p> */}
          </div>
        </div>
        <div className="section6">
          <div className="cs6">
            <p>Drag Application</p>
            <iframe
              width="340"
              height="220"
              src="https://www.youtube.com/embed/bunnIV4_23w"
              title="Drag Application"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
            <p>Fly ash Bucket Elevator</p>
            <iframe
              width="340"
              height="220"
              src="https://www.youtube.com/embed/BfMmGwNtAdI"
              title="Fly ash Bucket Elevator"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
          <div className="section7">
            <div className="cs7">
              <p>Fly ash Drag Feeder</p>
              <iframe
                width="340"
                height="220"
                src="https://www.youtube.com/embed/pBhOmEQzNH0"
                title="Fly ash Drag Feeder"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
              <p>Ropeway</p>
              <iframe
                width="340"
                height="220"
                src="https://www.youtube.com/embed/V_wJEVnPXvA"
                title="Ropeway"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
        <div className="section8">
          <div className="cs7">
            <p>Slat Conveyor for Caprive Power Plant</p>
            <iframe
              width="340"
              height="220"
              src="https://www.youtube.com/embed/qC6mlcKBKpo"
              title="Slat Conveyor for Caprive Power Plant"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        
      </div>
    </div>
  );
}

export default Cement;
